import { Input, Label } from "@twilio-paste/core";

import { Field } from "../../store/definitions";

type EmailFieldProps = {
    field: Field;
    onChange?: (newValue: string) => void;
    onKeyPress?: (e: React.KeyboardEvent<HTMLElement>) => void;
    value?: string;
};

export const EmailField = ({ field, onChange, onKeyPress, value }: EmailFieldProps) => {
    const { name, label, placeholder, required } = field;

    return (
        <>
            <Label htmlFor={name}>{label}</Label>
            <Input
                type="email"
                placeholder={placeholder}
                name={name}
                id={name}
                value={value ?? ""}
                onChange={(e) => onChange?.(e.target.value)}
                required={required}
                onKeyPress={(e) => onKeyPress?.(e)}
            />
        </>
    );
};
